import { Button, Modal, Spinner } from "react-bootstrap"; // Importamos Spinner
import imgUrl from "../util/imgUrl";
import { useEffect, useState } from "react";
import useAxios from "../hooks/useAxios";
import { FaFilePdf, FaCertificate } from "react-icons/fa";
import { downloadProductDoc } from "../util/downloadProductFile";

const DetailProductModal = ({ detailProduct, setDetailProduct, handleToggleVersion, orderHasProduct }) => {

    const [{ data, loading }, getProduct] = useAxios({}, { useCache: false, manual: true });
    const [downloadingKey, setDownloadingKey] = useState(null);

    useEffect(() => {
        if (detailProduct?.id) {
            getProduct({ url: `/products/${detailProduct?.id}` });
        }
    }, [detailProduct]);

    // Extraemos la info para limpiar el JSX
    const product = data?.data;

    const dataSheetUrl = product?.dataSheet || product?.data_sheet;
    const certificateUrl = product?.certificate;

    const handleDownload = async (productId, code, type) => {
        const key = `${productId}-${type}`;
        try {
            setDownloadingKey(key);
            const endpoint = `/products/${productId}/${type === 'data_sheet' ? 'data-sheet' : 'certificate'}/download`;
            const prefix = type === 'data_sheet' ? 'Ficha_Tecnica' : 'Certificado';
            await downloadProductDoc(endpoint, `${prefix}_${code || productId}.pdf`);
        } catch (err) {
            console.error(err);
            alert(`No se pudo descargar ${type === 'data_sheet' ? 'la ficha técnica' : 'el certificado'}`);
        } finally {
            setDownloadingKey(null);
        }
    };

    return (
        <Modal show={!!detailProduct} className="fade" size="lg" onHide={() => setDetailProduct(null)}>
            <Modal.Header>
                <Modal.Title>
                    {loading ? "Cargando producto..." : product?.name}
                </Modal.Title>
                <Button
                    variant=""
                    className="btn-close"
                    onClick={() => setDetailProduct?.(null)}
                />
            </Modal.Header>

            <Modal.Body style={{ minHeight: '200px' }}>
                {loading ? (
                    // --- VISTA DE LOADING ---
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Obteniendo detalles...</p>
                        </div>
                    </div>
                ) : (
                    // --- VISTA DE CONTENIDO ---
                    <>
                        <div className="row">
                            <div className="col-md-4">
                                <img
                                    src={imgUrl(product?.imagePath)}
                                    style={{ maxWidth: '100%', borderRadius: '10px' }}
                                    className="rounded"
                                    alt={product?.name}
                                />
                            </div>
                            <div className="col-md-8">
                                <div className="form-group my-2">
                                    <b>Descripción: </b> {product?.description || 'Sin descripción'}
                                </div>
                                <div className="form-group my-2">
                                    <b>Código: </b> {product?.code}
                                </div>
                                <div className="form-group my-2">
                                    <b>Precio: </b> ${product?.price}
                                </div>
                                <div className="form-group my-2">
                                    <b>Categoría: </b> {product?.category?.name}
                                </div>
                                {(dataSheetUrl || certificateUrl) && (
                                    <div className="d-flex gap-2 mt-3 flex-wrap">
                                        {dataSheetUrl && (
                                            <button
                                                type="button"
                                                onClick={() => handleDownload(product.id, product.code, 'data_sheet')}
                                                disabled={downloadingKey === `${product.id}-data_sheet`}
                                                className="btn btn-sm btn-outline-danger d-inline-flex align-items-center"
                                            >
                                                {downloadingKey === `${product.id}-data_sheet` ? (
                                                    <span className="spinner-border spinner-border-sm me-2" />
                                                ) : (
                                                    <FaFilePdf className="me-2" />
                                                )}
                                                Descargar Ficha Técnica
                                            </button>
                                        )}
                                        {certificateUrl && (
                                            <button
                                                type="button"
                                                onClick={() => handleDownload(product.id, product.code, 'certificate')}
                                                disabled={downloadingKey === `${product.id}-certificate`}
                                                className="btn btn-sm btn-outline-info d-inline-flex align-items-center"
                                            >
                                                {downloadingKey === `${product.id}-certificate` ? (
                                                    <span className="spinner-border spinner-border-sm me-2" />
                                                ) : (
                                                    <FaCertificate className="me-2" />
                                                )}
                                                Descargar Certificado
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        <hr />

                        <div className="row mt-4">
                            <div className="col-md-12 text-center">
                                <h4>Versiones</h4>
                            </div>
                            <table className="table text-center align-middle">
                                <thead>
                                    <tr>
                                        <th>Imagen</th>
                                        <th>Nombre</th>
                                        <th>Código</th>
                                        <th>Ficha Técnica</th>
                                        <th>Certificado</th>
                                        <th>Seleccionar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {product?.children?.length > 0 ? (
                                        product.children.map((childProduct, i) => (
                                            <tr key={childProduct.id || i}>
                                                <td>
                                                    <img
                                                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                        src={imgUrl(childProduct?.imagePath)}
                                                        alt=""
                                                    />
                                                </td>
                                                <td>{childProduct?.name}</td>
                                                <td>{childProduct?.code}</td>
                                                <td>
                                                    {(childProduct?.dataSheet || childProduct?.data_sheet) ? (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleDownload(childProduct.id, childProduct.code, 'data_sheet')}
                                                            disabled={downloadingKey === `${childProduct.id}-data_sheet`}
                                                            className="btn btn-xs btn-outline-danger d-inline-flex align-items-center"
                                                            title="Descargar Ficha Técnica"
                                                        >
                                                            {downloadingKey === `${childProduct.id}-data_sheet` ? (
                                                                <span className="spinner-border spinner-border-sm me-1" style={{ width: '10px', height: '10px' }} />
                                                            ) : (
                                                                <FaFilePdf className="me-1" />
                                                            )}
                                                            Ficha
                                                        </button>
                                                    ) : (
                                                        <span className="text-muted small">--</span>
                                                    )}
                                                </td>
                                                <td>
                                                    {childProduct?.certificate ? (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleDownload(childProduct.id, childProduct.code, 'certificate')}
                                                            disabled={downloadingKey === `${childProduct.id}-certificate`}
                                                            className="btn btn-xs btn-outline-info d-inline-flex align-items-center"
                                                            title="Descargar Certificado"
                                                        >
                                                            {downloadingKey === `${childProduct.id}-certificate` ? (
                                                                <span className="spinner-border spinner-border-sm me-1" style={{ width: '10px', height: '10px' }} />
                                                            ) : (
                                                                <FaCertificate className="me-1" />
                                                            )}
                                                            Certificado
                                                        </button>
                                                    ) : (
                                                        <span className="text-muted small">--</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <input
                                                        onChange={() => handleToggleVersion(childProduct)}
                                                        checked={orderHasProduct(childProduct?.id)}
                                                        type="checkbox"
                                                        className="form-check-input"
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={6}>
                                                <h5 className="text-muted my-3">No hay versiones disponibles.</h5>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                <button
                    onClick={() => setDetailProduct(null)}
                    className="btn btn-secondary"
                    disabled={loading}
                >
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default DetailProductModal;